import { HomeRemoveOutlineIcon } from './HomeRemoveOutlineIcon';

/**
 * author: Michael Irigoyen
 * id CD3129FD-EDCB-4B65-85F8-900E59E308B7
 * name home-remove-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-remove-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseRemoveOutlineIcon = HomeRemoveOutlineIcon;
export default HouseRemoveOutlineIcon